'use strict';

app.directive('rmPreloader', function ($timeout, $preloader) {
  return {
    restrict: 'C',
    link: function (scope, element) {
      scope.$watch($preloader.state, function () {
        $timeout(function () {
          element.toggleClass('ng-hide', !$preloader.state());
        }, 150, false);
      });
    }
  };
});
